import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonComponent } from '@mwe/ui/components';
import { IkpStaticContentService } from '../../../../service/static-content/ikp-static-content.service';

@Component({
  selector: 'ikp-ummeldung-instructions-button',
  imports: [ButtonComponent],
  templateUrl: './instructions-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstructionsButtonComponent {
  private readonly staticContentService = inject(IkpStaticContentService);

  openInstructions(): void {
    const url = this.staticContentService.getUmmeldungAnleitungPdfUrl();
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
